import { render, staticRenderFns } from "./BannerEdit.vue?vue&type=template&id=523f6b5a&scoped=true&"
import script from "./BannerEdit.vue?vue&type=script&lang=js&"
export * from "./BannerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523f6b5a",
  null
  
)

export default component.exports